// Full-document render of the sealy ProductComparePage: PageSkeleton (the
// React document shell) wrapping the existing compare-page body assembly
// (which reproduces the <section class="product-compare-page-block"> chrome).
import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";
import { SealyProductComparePageBody as ProductComparePageBody } from "../components/SealyProductComparePageBody";

// Mutable reactivated props (not Immutable<>): this template composes the
// in-tree SiteHeader/RichNavigation chain via PageSkeleton, which is typed
// with mutable reactivated props (see PageSkeleton). The body template accepts
// Immutable props, to which these are assignable.
export const Template = (
    props: templates.SealyProductComparePageTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <ProductComparePageBody page={props.page} />
    </PageSkeleton>
);
